/**
 * Field Type Utilities for FormCrafter
 * Functions for mapping and checking field types
 */

import {
  FIELD_TYPE_MAP,
  FILE_FIELD_TYPES,
  DEFAULT_FIELD_TYPE,
} from '../../constants/formCrafter.constant';

/**
 * Maps legacy formBuilder field types to FormCrafter types
 * @param {string} type - Original field type
 * @returns {string} - Normalized FormCrafter field type
 */
export const mapFieldType = (type) => {
  if (!type) {
    return DEFAULT_FIELD_TYPE;
  }

  const normalizedType = String(type).toLowerCase().trim();
  return (
    FIELD_TYPE_MAP[normalizedType] || FIELD_TYPE_MAP[type] || DEFAULT_FIELD_TYPE
  );
};

/**
 * Checks if a field type is a file-related type
 * @param {string} type - Field type to check
 * @returns {boolean}
 */
export const isFileType = (type) => {
  if (!type) return false;
  const normalizedType = String(type).toLowerCase().trim();
  return (
    FILE_FIELD_TYPES.includes(normalizedType) || FILE_FIELD_TYPES.includes(type)
  );
};

/**
 * Checks if a field type supports multiple options (select, radio, checkbox)
 * @param {string} type - Field type to check
 * @returns {boolean}
 */
export const hasOptions = (type) => {
  if (!type) return false;
  const normalizedType = String(type).toLowerCase().trim();
  return [
    'select',
    'radio',
    'checkbox',
    'radio-group',
    'checkbox-group',
  ].includes(normalizedType);
};

/**
 * Checks if a field type is a date/time type
 * @param {string} type - Field type to check
 * @returns {boolean}
 */
export const isDateTimeType = (type) => {
  if (!type) return false;
  const normalizedType = String(type).toLowerCase().trim();
  return [
    'date',
    'datetime',
    'datetime-local',
    'time',
    'month',
    'week',
  ].includes(normalizedType);
};

/**
 * Checks if a field type is a boolean type
 * @param {string} type - Field type to check
 * @returns {boolean}
 */
export const isBooleanType = (type) => {
  if (!type) return false;
  const normalizedType = String(type).toLowerCase().trim();
  return ['switch', 'checkbox'].includes(normalizedType);
};
